<template>
  <InputGroup
    class="markdown-input"
    :name="name"
    :label="label"
    :description="description"
  >
    <template #secondary>
      <Button
        as="a"
        href="https://approachguides.com/markdown-pointers/"
        target="_blank"
        variant="link"
        :ui="{ base: 'text-xs text-supplement hover:text-primary-hover font-medium' }"
      >
        <span clas="flex items-center">
          <Icon
            icon="markdown"
            prefix="fab"
          />
          <span class="ml-2">{{ $t('formatting_help') }}</span>
        </span>
      </Button>
    </template>

    <TextInput
      :model-value="modelValue"
      :name="name"
      v-bind="$attrs"
      textarea
    />
    <!-- <Alert v-show="lengthFeedback.status" :type="lengthFeedback.status" :content="lengthFeedback.content"></Alert> -->
  </InputGroup>
</template>

<script setup lang="ts">
defineProps<{
  // Shared props
  name: string
  // Input Group props
  label?: string
  description?: string
  // Text Input Props
  modelValue: string | null
  disabled?: boolean
  textarea?: boolean
}>()
</script>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>
